export default __webpack_public_path__ + "static/media/userOne.a70b5f37.svg";